<div class="sidenav-sm">
  <mat-toolbar class="fixed-top justify-content-between prada-white-bg mat-elevation-z2">
    <h1 class="flex-grow-1">
      <b *ngIf="mode === 'update'">{{ 'COMMON.FS.UPDATE' | translate }}</b>
      <b *ngIf="mode === 'filter'">{{ 'COMMON.FS.FILTER' | translate }}</b>
    </h1>
    <button mat-icon-button
      (click)="closeSidenav()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="sidebar-content">
    <form [formGroup]="form"
      *ngIf="form && formItemsConfig">
      <div class="d-flex flex-column p-3">

        <bitf-mat-form-item class="w-100"
          [formItem]="formItemsConfig.name"
          formItemControlName="name"
          [form]="form"></bitf-mat-form-item>

        <div class="row">
          <bitf-mat-form-item class="col-24 col-sm-12"
            [formItem]="formItemsConfig.createdBy"
            formItemControlName="createdBy"
            [form]="form"></bitf-mat-form-item>

          <bitf-mat-form-item class="col-24 col-sm-12"
            [formItem]="formItemsConfig.modifiedBy"
            formItemControlName="modifiedBy"
            [form]="form"></bitf-mat-form-item>
        </div>

        <div class="mb-1">
          {{'COMMON.LABEL.CREATED' | translate}}
        </div>
        <div class="row">
          <bitf-mat-form-item class="col-12"
            [formItem]="formItemsConfig.createdFrom"
            formItemControlName="createdFrom"
            [form]="form"></bitf-mat-form-item>

          <bitf-mat-form-item class="col-12"
            [formItem]="formItemsConfig.createdTo"
            formItemControlName="createdTo"
            [form]="form"></bitf-mat-form-item>
        </div>

        <div class="my-1">
          {{'COMMON.LABEL.MODIFIED' | translate}}
        </div>
        <div class="row">
          <bitf-mat-form-item class="col-12"
            [formItem]="formItemsConfig.modifiedFrom"
            formItemControlName="modifiedFrom"
            [form]="form"></bitf-mat-form-item>

          <bitf-mat-form-item class="col-12"
            [formItem]="formItemsConfig.modifiedTo"
            formItemControlName="modifiedTo"
            [form]="form"></bitf-mat-form-item>
        </div>

        <ng-container
          *bitfUiRoleManager="{action: ERoleActions.SHOW_TAG, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}">
          <bitf-mat-form-option *ngIf="!isAdvancedSearch"
            class="w-100"
            appearance="outline"
            matFormFieldClass="w-100"
            [formOptions]="formItemsConfig.tags"
            [useObject]="true"
            selectFormControlName="tags"
            [form]="form"></bitf-mat-form-option>
        </ng-container>
      </div>
    </form>
  </div>

  <mat-toolbar class="fixed-bottom justify-content-end prada-white-bg mat-elevation-z2"
    *ngIf="form && formItemsConfig">
    <button mat-button
      *ngIf="mode === 'filter'"
      color="primary"
      (click)="resetForm()"
      class="col-auto mr-2">
      <span>{{ 'COMMON.LABEL.RESET' | translate }}</span>
    </button>

    <button mat-raised-button
      *ngIf="form"
      [disabled]="!form.valid"
      color="primary"
      (click)="submitForm()"
      class="col-auto">
      <span *ngIf="mode === 'update'">{{ 'COMMON.NEWS.UPDATE' | translate }}</span>
      <span *ngIf="mode === 'filter'">{{ 'COMMON.LABEL.TO_FILTER' | translate }}</span>
    </button>
  </mat-toolbar>
</div>